import React, { PropsWithChildren, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import useMessage from 'Hooks/useMessage';
import MessageError from 'Components/Common/MessageError';

interface IDropProps {
  acceptTypes: string;
  handleChange: (files: File[]) => void;
  messageAlert?: string;
  messageError?: string;
  title?: string;
  isDisable?: boolean;
  onClickError?: () => void;
  maxHeight?: string;
}

const DropzoneDigitalSquare = ({
  acceptTypes,
  handleChange,
  messageAlert,
  title,
  messageError,
  isDisable = false,
  maxHeight,
  onClickError,
}: PropsWithChildren<IDropProps>): JSX.Element => {
  const { openMessage } = useMessage();
  const { fileRejections, getRootProps, getInputProps } = useDropzone({
    accept: acceptTypes,
    onDrop: (acceptedFiles) => {
      if (!isDisable) handleChange(acceptedFiles);
    },
    disabled: isDisable,
  });

  useEffect(() => {
    fileRejections.map(({ errors }) => {
      errors.map((error) => {
        if (error.code === 'file-invalid-type') {
          openMessage({
            variant: 'error',
            message: messageAlert,
          });
        }
      });
    });
  }, [fileRejections, openMessage, messageAlert]);

  return (
    <>
      <div
        className="h-100 w-100 d-flex flex-column align-items-center gap-2"
        style={{
          maxHeight: maxHeight ?? '100%',
        }}
      >
        <div className="h-100 w-100">
          <div
            {...getRootProps({
              style: {
                cursor: isDisable ? 'not-allowed' : 'pointer',
              },
            })}
            className="d-flex align-items-center justify-content-center py-3 h-100 border rounded bg-light"
          >
            <div className="px-1">
              <p className="text-muted">{title}</p>
              <input {...getInputProps()} readOnly={isDisable} />
            </div>
          </div>
        </div>
        {messageError && (
          <div onClick={onClickError} onKeyDown={onClickError}>
            <MessageError message={messageError} />
          </div>
        )}
      </div>
    </>
  );
};

export default DropzoneDigitalSquare;
